import {BetlevelMenuViewEvents} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuViewEvents';
import {ButtonsMenu} from '@fantasmagames/slot/src/modules/popupmenus/ButtonsMenu';
import {GenericButton} from '@fantasmagames/slot/src/modules/popupmenus/GenericButton';
import {Logic} from '@fantasmagames/slot/src/logic/Logic';

export class BetlevelMenuView extends ButtonsMenu {
	protected _lastBet: number;
	protected _betValue: number;
	protected _betDefault: number;

	protected _currentBalance: number;

	public init(): void {
		super.init();

		this.callback = this.setBet;
		if (this.device.isMobile) {
			this.tapDownCallback = this.onTapDown;
			this.mouseOutCallback = this.onMouseOut;
		}
		this.title = 'BET LEVEL';
	}

	public translate(): void {
		const titleText: string = this.translator.getObject('BaseStrings', 'features', 'g_betlevel') || 'BET LEVEL';
		this.title = titleText.toUpperCase();
	}

	public show(): void {
		super.show();

		this.restoreToLastBet(this.lastBet);
	}

	public preCallback(valueId: number, ...args: any[]): void {
		for (const button of this._buttons) {
			if (button.id !== valueId && this.validateButton(button)) {
				button.resetState();
			}
		}
	}

	public setupButtonStates(): void {
		if (this.lastBet > this.currentBalance) {
			const maxButton = this.getHighestValidButton();
			if (maxButton) {
				this.lastBet = maxButton.id;
			}
		}

		this.restoreToLastBet(this.lastBet);
		this.preCallback(this.lastBet);
	}

	public validateAllButtons(): void {
		this._buttons.forEach((button) => {
			this.validateButton(button);
		});
	}

	public validateButton(button: GenericButton): boolean {
		if (button.id > this.currentBalance) {
			button.disable();

			return false;
		}

		button.enable();

		return true;
	}

	public restoreToLastBet(value: number): void {
		const lastBetButton = this.findButtonByValue(value);

		if (lastBetButton) {
			lastBetButton.forceClicked();
			lastBetButton.setSelected();
		}
	}

	public getHighestValidButton(): GenericButton {
		let highestValidValue = 0;

		for (const button of this._buttons) {
			if (this.validateButton(button)) {
				highestValidValue = highestValidValue < button.id ? button.id : highestValidValue;
			}
		}

		return this.findButtonByValue(highestValidValue);
	}

	public getLowerButton(): void {}

	protected onMouseOut(value: number): void {
		for (const button of this._buttons) {
			if (this.validateButton(button)) {
				button.resetState();
			}
		}

		this._acceptEnabled = false;
		this._acceptButton.disable();
	}

	protected onTapDown(value: number): void {
		this.preCallback(value);

		this._acceptEnabled = true;
		this._acceptButton.enable();

		this.betValue = value;
	}

	protected setBet(value: number, isRealClick: boolean): void {
		if (isRealClick) {
			this.soundPlayer.play('buttonClick');
		}

		this.preCallback(value);

		this._acceptEnabled = true;
		this._acceptButton.enable();

		this.betValue = value;
	}

	protected listenToMouseWheelInput(): void {
		this.blockParentPageScroll();
	}

	protected blockParentPageScroll(): void {
		// Copied from page showing example blocking scroll input depending on mouseover.
		// 2017 recommended event
		document.body.addEventListener(
			'wheel',
			(event) => {
				event.preventDefault();
			},
			false,
		);

		// Before 2017, IE9, Chrome, Safari, Opera
		document.body.addEventListener(
			'mousewheel',
			(event) => {
				event.preventDefault();
			},
			false,
		);

		// Old versions of Firefox
		document.body.addEventListener(
			'DOMMouseScroll',
			(event) => {
				event.preventDefault();
			},
			false,
		);
	}
	protected stopListeningToMouseWheelInput(): void {}

	protected emitAccepted(): void {
		this.emit(BetlevelMenuViewEvents.ACCEPTED);
		this.lastBet = this.betValue;
	}

	protected emitButtonPressed(): void {
		this.emit(BetlevelMenuViewEvents.BUTTON_PRESSED);
	}

	protected emitCancelled(): void {
		this.emit(BetlevelMenuViewEvents.CANCELLED);
	}

	protected emitOpened(): void {
		this.emit(BetlevelMenuViewEvents.BET_LEVEL_MENU_OPENED);
	}

	protected emitClosed(): void {
		this.emit(BetlevelMenuViewEvents.BET_LEVEL_MENU_CLOSED);
	}

	protected formatText(text: any): string {
		return this.currencyFormatter.formatCurrency(text, true);
	}

	protected findButtonByValue(value: number): GenericButton {
		return this._buttons.find((button) => button.id === value);
	}

	public set betValue(v: number) {
		this._betValue = v;
	}

	public get betValue(): number {
		return this._betValue;
	}

	public set defaultBet(n: number) {
		this._betDefault = n;
	}

	public set lastBet(value: number) {
		// this.restoreToLastBet(value);
		this._lastBet = value;
	}

	public get lastBet(): number {
		return this._lastBet;
	}

	public set currentBalance(value: number) {
		this._currentBalance = value;
	}

	public get currentBalance(): number {
		return this._currentBalance;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuView.ts